import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OverlayService } from '../overlay/overlay.service';
import { tools } from '../services/tools';
import { DurationPickerComponent } from './lib/duration-picker.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-overlay-duration-picker',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './overlay-duration-picker.component.html',
  styleUrls: ['./overlay-duration-picker.component.scss']
})
export class OverlayDurationPickerComponent implements OnInit, AfterViewInit {
  @Input() initialValue: number = 0;
  @Input() autoOpen: boolean = false;
  @Output() public outputValue: EventEmitter<any> = new EventEmitter<any>();

  public pickerOutputDisplay: string = '';

  constructor(
    private overlayService: OverlayService,
    private tools: tools,
  ) { }

  ngOnInit(): void {
    if (this.initialValue != null) this.pickerOutputDisplay = this.tools.timeParser(this.initialValue);
    else this.pickerOutputDisplay = '0 sec';
  }

  ngAfterViewInit() {
    if (this.autoOpen) this.openDurationPicker();
  }

  public openDurationPicker(event?: any) {
    if (event != null) event.stopPropagation();
    const ref = this.overlayService.open(DurationPickerComponent, this.initialValue, {
      styleDefinition: {
        width: '436px',
      },
    });
    ref.afterClosed$.subscribe((res: any) => {
      if (res?.data != null) {
        this.pickerOutputDisplay = this.tools.timeParser(res.dasta);
        this.outputValue.emit(res.data);
      }
    });
  }
}
